









































  import { computed, defineComponent } from 'vue'
  import useCurrentInstance from '~/utils/useCurrentInstance'

  export default defineComponent({
    name: 'OneCmsBrandsList',
    setup(_, { emit }) {
      const vm = useCurrentInstance()
      const highlightedBrandsTree = computed(() => vm.$store.getters['brands/getHighlightedBrandsTree'])

      const fetchBrandsTree = async () => {
        try {
          if (!highlightedBrandsTree.value.length) {
            await vm.$store.dispatch('brands/fetchHighlightedBrandsTree')
          }
        } catch (error) {
          // @ts-ignore
          vm.$logger.error(error)
        }
      }

      const onItemClick = (item: any) => {
        emit('item-click', item)
      }

      fetchBrandsTree()

      return {
        highlightedBrandsTree,
        onItemClick,
      }
    },
  })
